<template>
  <!-- 首页头部组件 -->
  <!-- <transition name="el-fade-in-linear"> -->
  <div class="header">
    <div class="mobile">
      <a title="网站信息无障碍工具条" href="javascript:;" class="easyWzaBtn" style="color: #1c74cd;line-height: 25px;">【无障碍阅读】</a>
      <a href="https://oa.shx93.gov.cn:8080" target="_Blank" style="color: #1c74cd;line-height: 25px;float: right;">【OA办公协同】</a>
    </div>
    <div class="head" style="padding: 10px;height: 25px;">
      <div class="head-left">
        <div>
          <!-- 太阳湾无障碍 -->
          <!-- <a id="wzayd" title="网站信息无障碍工具条" href="javascript:;" class="wzayd" accesskey="g"
            style="color: #1c74cd;line-height: 25px;">【无障碍阅读】</a> -->
          <!-- 青松无障碍 -->
          <a title="网站信息无障碍工具条" href="javascript:;" class="easyWzaBtn"
            style="color: #1c74cd;line-height: 25px;">【无障碍阅读】</a>
          <!-- <a href="javascript:;" class="easyElderBtn"> 长者助手</a> -->
        </div>
        <div class="weather" v-if="weatherList" @click="toWeatherDetail" style="line-height: 25px">
          <span>
            <span>西安：</span>
            {{ weatherList.text_day }} {{ weatherList.low }}°~{{ weatherList.high }}°<i
              class="el-icon-d-arrow-right"></i>
          </span>
        </div>
        <!-- 通知公告 -->
        <!-- <div class="notice-list">
          <div class="left-form">通知公告：</div>
          <div class="notice-box" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
            <transition name="notice-slide">
              <p class="notice-item" :key="noticeList.id" @click="gotoNoticeDetail(noticeList.mesId)">
                {{ noticeList.text }}
              </p>
            </transition>
          </div>
          <div class="leftButton">
            <router-link to="/noticeList" class="more">更 多</router-link>
          </div>
        </div> -->
        <div class="right" style="height: 30px">
          <el-input placeholder="请输入内容" v-model="inpVal" class="input-with-select" @keyup.enter="keywordsSearch">
            <el-button slot="append" icon="el-icon-search" @click="keywordsSearch"></el-button>
          </el-input>
          <!-- <div class="example" style="margin-top: 7px">
              <input type="text" v-model="inpVal" placeholder="请输入" name="search" @keyup.enter="keywordsSearch"
                style="width: 140px; height: 25px" />
              <button type="submit" @click="keywordsSearch">
                <img src="../../../src/assets/image/搜索.png" alt="" class="rightImg" style="height: 20px" />
              </button>
            </div> -->
        </div>
      </div>

      <!-- <a href="http://61.185.253.210:8080" target="_blank " style="color: #1c74cd;line-height: 50px;">【长者模式】</a> -->
      <div class="icon" style="margin-right: 10px;line-height: 25px;">
        <img src="@assets/image/nav/icon_home.png" title="设为首页" @click="SetHome" />
        <img src="@assets/image/nav/icon_fav.png" title="加入收藏" @click="addToFavorite" />
        <img class="weixin1" src="@assets/image/nav/icon_weixin.png" />
        <img class="weixin2" src="@assets/image/picture/1234.jpg" alt=""
          style="width: 80px;height: 80px;margin-left: 50px;" />
        <!-- <img class="computer1" src="../../assets/image/nav/icon_computer.png" /> -->
        <!-- <img class="computer2" src="../../assets/image/picture/erweima1.jpg" alt="" -->
        <!-- style="width: 80px;height: 80px;margin-left: 50px;" /> -->
      </div>
    </div>
    <!-- 上线公告（只在首页显示） -->
    <!-- <div class="fixed_box" v-if="fixed_box_isShow && $route.path === '/'">
      <i class="el-icon-close" style="float:right;margin-top: -14px;" @click="closeFixedBox"></i>
      <p>九三学社陕西省委员会新版网站经过半年多的升级改版，终于与大家见面了。</p>
      <p>新版网站从网站架构、栏目设置和版面设计上进行了系统优化，以期打造一个特色鲜明、内容丰富、浏览便捷、信息检索精准的门户网站，让用户获得最佳的浏览效果和最全的信息资讯。</p>
      <p>欢迎广大九三学社社员和各界朋友访问浏览，如您在使用过程中有任何意见或建议，请及时与我们联系。</p>
      <p>联系人：王婷</p>
      <p>联系电话：029-63903372</p>
    </div> -->
    <!-- ------------------------------------------- -->
    <div class="title-img" style="position: relative">
      <img src="@assets/image/u0.png" style="width: 40%; position: absolute; top: 30%;left: 3%;z-index: 2" />
      <!-- <img src="../../../src/assets/image/t2.png" style="width: 100%; z-index: 1" /> -->
      <!-- <img :src="`https://jiusan.htseasky.com:9001/prod-api${currentImage}`" style="width: 100%; z-index: 1"> -->
      <img :src="`http://www.shx93.gov.cn/prod-api${currentImage}`" style="width: 100%; z-index: 1">
    </div>
    <div class="nav">
      <ul class="wrap navtitle">
        <li class="dd" :class="{ isSelect: !currentId }">
          <a href="#" @click.prevent="currentId = ''; $router.push({ path: '/' })" style="color: #fff;">首页<i></i></a>
        </li>
        <!-- 菜单栏 -->
        <li v-for="(item, index) in firstNavList" :key="item.id" @mouseenter="enterNav(item.id, index)"
          @mouseleave="leaveNav(item.id, index)" :class="{ isSelect: item.id === currentId }">
          <a href="#" @click.prevent="routerPush(item.id, item.navName)">{{ item.navName }}<i
              :class="{ active: item.navName == currentMenu }"></i></a>
          <div class="newsTitle show" ref="NavRef" :class="{ active: index === currentMenuIndex }"
            @mouseleave="leaveNav(item.id, index)">
            <ul>
              <li class="secondMenu">
                <!-- 二级菜单 -->
                <a href="#" @click.prevent="toDetail(second.id, second.navName, item.id)"
                  v-for="second in secondNavList" :key="second.id">{{ second.navName }}</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!-- 面包屑 -->
    <div style="padding:10px 0px;width:1170px;margin: 0 auto;text-align: left;margin-top:10px" class="breadcrumb"
      v-if="$route.path !== '/'">
      <div @click="back" style="cursor: pointer;color: #4d4f53" class="breadcrumb_back">返回上一页</div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import axios from 'axios';
import { isMobile } from "@/utils/common.js";
export default {
  data() {
    return {
      currentMenu: '',
      firstNavList: [],
      secondNavList: [],
      currentMenuIndex: null,
      weatherList: {
        text_day: '',
        low: '',
        high: ''
      },
      // 顶部图片
      topBannerPic: [],
      // 顶部图片
      topCurrentIndex: 0,
      intervalId: null,
      noticeArr: [],
      number: 0,
      inpVal: "",
      currentId: '',
      fixed_box_isShow: true
    };
  },
  mounted() {
    this.scrollMove();
    this.getNoticeList();
  },
  computed: {
    currentImage() {
      return this.topBannerPic[this.topCurrentIndex] && this.topBannerPic[this.topCurrentIndex].mediaPath
    },
    noticeList() {
      return {
        id: this.number,
        text: this.noticeArr[this.number] && this.noticeArr[this.number].title,
        mesId: this.noticeArr[this.number] && this.noticeArr[this.number].id,
      };
      timer: nuul
    },
  },
  created() {
    // 查询栏目列表
    // console.log('', this.$route.query);
    this.currentMenu = this.$route.query.name
    this.getNavList();
    // 获取新闻列表
    // this.getNewsList();
    this.getWeatherInfo()
    // 获取顶部图片
    this.getTopBannerPic()
    this.startCarousel()
  },
  beforeUnmount() {
    this.stopCarousel();
  },
  watch: {
    $route: {
      handler(newVal) {
        if (newVal.path === '/') {
          localStorage.setItem('currentId', '')
        } else {
          this.currentId = localStorage.getItem('currentId') ? localStorage.getItem('currentId') : '';
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeFixedBox() {
      this.fixed_box_isShow = false
    },
    back() {
      if (this.$route.path === '/') {
        this.$router.push('/');
        return
      }
      this.$router.go(-1);
    },
    async gotoNoticeDetail(_id) {
      this.$router.push(`/noticeDetail?tm=${_id}`)
    },
    // 搜索
    async keywordsSearch() {
      this.$router.push(`/newsSecondDetail?keyVal=${this.inpVal}`)
    },
    scrollMove() {
      this.timer = setTimeout(() => {
        if (this.number === this.noticeArr.length - 1) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.scrollMove();
      }, 3000);
    },
    //鼠标进入
    mouseEnter() {
      clearInterval(this.timer);
    },
    //鼠标离开
    mouseLeave() {
      this.scrollMove();
    },
    // 获取首页通知列表
    async getNoticeList() {
      const { status, data } = await this.$api.nav.getNoticeList();
      // 通知列表只保留前两条，点更多可以查看所有
      this.noticeArr = data.rows;
    },
    // 获取顶部图片
    async getTopBannerPic() {
      let res_top = await this.$api.nav.getBannerPic(1);
      // console.log('toppic-toppic-toppic', res_top);
      this.topBannerPic = res_top.data.rows
    },
    // 顶部图片轮播
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.nextImage();
      }, 4000);
    },
    // 停止轮播
    stopCarousel() {
      clearInterval(this.intervalId);
    },
    nextImage() {
      this.topCurrentIndex = (this.topCurrentIndex + 1) % this.topBannerPic.length;
    },
    prevImage() {
      this.topCurrentIndex = (this.topCurrentIndex - 1 + this.topBannerPic.length) % this.topBannerPic.length;
    },

    toWeatherDetail() {
      window.open('http://www.weather.com.cn/weather40d/101110101.shtml')
    },
    getWeatherInfo() {
      axios.get('https://api.seniverse.com/v3/weather/daily.json?key=SBU_mxtltYNY22BYC&location=xian&language=zh-Hans&unit=c')
        .then(res => {
          // console.log('天气列表',res);
          this.weatherList.text_day = res.data.results[0].daily[0].text_day
          this.weatherList.low = res.data.results[0].daily[0].low
          this.weatherList.high = res.data.results[0].daily[0].high
          // console.log(this.weatherList);
        })
    },
    addToFavorite() {
      var d = "";
      var c = "";
      if (document.all) {
        window.external.AddFavorite(d, c);
      } else {
        if (window.sidebar) {
          window.sidebar.addPanel(c, d, "");
        } else {
          alert(
            "对不起，您的浏览器不支持此操作!\n请您使用菜单栏或Ctrl+D收藏本站。"
          );
        }
      }
    },
    //设为首页
    SetHome(obj) {
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage("http://www.93.gov.cn/");
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "抱歉，此操作被浏览器拒绝！\n\n请在浏览器地址栏输入'about:config'并回车然后将[signed.applets.codebase_principal_support]设置为'true'"
            );
          }
        } else {
          alert(
            "抱歉，您的浏览器不支持自动设置首页, 请使用浏览器菜单手动设置!"
          );
        }
      }
    },
    toDetail(_id, navName, id) {
      this.currentId = id;
      localStorage.setItem('currentId', id)
      // /selfConstruction?tm=1146097762320777216&name=自身建设
      // l?tm=1146098033667080192&navName=思想建设  思想建设
      // console.log('toDetail', navName, id);

      if (navName === '联系我们') {
        this.$router.push(`/AboutUs`);
      } else if (navName === '九三学社简介') {
        this.$router.push('/XSJJ?tm=1155937645809893389')
      }
      else if (navName === '社省委简介') {
        this.$router.push('/SSWJJ?tm=1155937645809893390')
      }
      else if (id == '1139884679738949632') {
        this.$router.push(`/introduce?tm=${id}&name=本社介绍&childId=${_id}`);
      }
      else if (['全国人大代表', '全国政协委员', '两院院士'].includes(navName)) {
        this.$router.push(`/newsList?tm=${_id}&navName=${navName}&stitle=${navName}`)
      }
      else {
        // console.log('navNamenavNamenavName', navName);
        // 如果navName是'思想建设', '组织建设', '机关建设'的其中一个
        if (['思想建设', '组织建设', '机关建设'].includes(navName)) {
          // /selfConstruction?tm=1146097762320777216&name=自身建设
          this.$router.push(`/selfConstruction?tm=1146097762320777216&name=自身建设&isSingle=true&navName=${navName}`)
        } else {
          this.$router.push(`/newsSecondDetail?tm=${_id}&navName=${navName}`)
        }
        // 二级菜单点击跳转
        // this.$router.push(`/newsList?tm=${_id}&name=${navName}`)

        // this.$router.push({ name: "routeSecond", params: { id: _id } });
      }
    },
    // 菜单栏点击跳转
    async routerPush(_id, navName) {
      this.currentId = _id;
      localStorage.setItem('currentId', _id)
      this.currentMenu = navName
      // console.log('对应的第一个二级菜单的 id', this.secondNavList);
      // console.log("_id", _id, navName);
      if (navName === '联系我们') {
        this.$router.push(`/AboutUs`);
      } else if (navName === '本社介绍') {
        // console.log(navName);
        this.$router.push(`/introduce?tm=${_id}&name=本社介绍`);
      } else if (['自身建设', '社会服务', '参政议政', '新闻集萃', '社员风采'].includes(navName)) {
        if (isMobile) await this.enterNav(_id, 0)
        this.$router.push(`/selfConstruction?tm=${_id}&name=${navName}`);
      } else {
        if (isMobile) {
          await this.enterNav(_id, 0)
        }
        this.$router.push(`/newsList?tm=${_id}&name=${navName}&stm=${this.secondNavList[0].id}`);
        // this.$router.push({name:'routeNewsList',params:{id:_id,name:navName}})
      }
    },
    // 查询栏目列表
    async getNavList() {
      // 获取一级菜单项
      let res = await this.$api.nav.getNavList(1, 0);
      // console.log('res',res);
      this.firstNavList = res.data.data;
      // console.log('获取一级菜单项',this.firstNavList);
      // let currentNavName=this.$route.query.name
      // this.currentMenuIndex = this.firstNavList.findIndex(v=>v.navName==currentNavName)
      // console.log(' this.currentMenuIndex',);
    },
    // 移入移出菜单
    async enterNav(_id, index) {
      // console.log(4444, _id, index, this.$refs.NavRef);
      // console.log(_id);
      // 用一级菜单的 id 获取它对应的二级菜单
      let res = await this.$api.nav.getNavList(1, _id);
      // console.log(res.data.data);
      this.secondNavList = res.data.data;

      this.currentMenuIndex = index;
      this.$refs.NavRef.forEach((item, inx) => {
        if (index === inx) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }

      })
      // console.log(this.secondNavList);
      // 显示二级菜单
      // this.$refs.NavRef[index].style.height = "block";
      // document.getElementsByClassName('newsTitle')[index].style.display = 'block'
    },
    leaveNav(_id, index) {
      this.currentMenuIndex = null;
      // console.log(_id);
      // 鼠标移出隐藏二级菜单列表
      // console.log(1111111111111, this.$refs.NavRef);
      this.$refs.NavRef.forEach(item => {
        item.style.display = "none";
      })
    },
  },
  beforeDestroy() {
    localStorage.setItem('currentId', this.currentId)
  }
};
</script>

<style lang="scss" scoped>
@import "../../common/css/swiper.css";

// .transition-box {
//   margin-bottom: 10px;
//   width: 200px;
//   height: 100px;
//   border-radius: 4px;
//   background-color: #409EFF;
//   text-align: center;
//   color: #fff;
//   padding: 40px 20px;
//   box-sizing: border-box;
//   margin-right: 20px;
// }

* {
  list-style: none;
  text-decoration: none;
}

.dd {
  font-weight: bold;
  color: #fff;
  /* color: #3689ff; */
}

.OA {}

.mobile {
  display: none;
}

/* 头部 */
.header {
  width: 100%;
  position: relative;

  .login_box {
    line-height: 25px;
    margin-right: 10px;
    flex: 1;

    button {
      margin-left: 10px;
      background-color: #426FB0;
      color: white;
      border: none;
      text-align: center;
      width: 80px;
      height: 30px;
      margin-left: 10px;
      border-radius: 4px;
      letter-spacing: 2px;

      &:hover {
        cursor: pointer;
      }
    }

    input {
      outline: none;
      background-color: #F1F1F1;
      border: 1px solid #BBBBBB;
      border-radius: 3px;
    }
  }

  .head {
    width: 1250px;
    margin: auto;
    display: flex;
    justify-content: space-around;

    .head-left {
      display: flex;
      align-items: center;
    }

    .notice-list {
      display: flex;
      align-items: center;
      margin-left: 30px;

      .left-form {
        color: #1c74cd;
        font-weight: 600;
        letter-spacing: 2px;
        text-align: center;
      }

      .notice-box {
        min-width: 400px;
        height: 26px;
        overflow: hidden;
        position: relative;
        text-align: left;
        cursor: pointer;
      }

      .notice-item {
        width: 100%;
        height: 26px;
        line-height: 26px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .notice-slide-enter-active,
      .notice-slide-leave-active {
        transition: all 0.8s linear;
      }

      .notice-slide-enter {
        top: 26px;
      }

      .notice-slide-leave-to {
        top: -26px;
      }

      .leftButton {
        background-color: rgb(210, 232, 253);
        border: none;
        padding: 2px 11px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 13px;
        border-radius: 20px;

        .more {
          color: rgb(28, 116, 205);
          font-weight: 700;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 50px;
      padding-right: 0;
      box-sizing: border-box;

      ::v-deep {
        .el-input-group>.el-input__inner {
          height: 30px;
        }
      }
    }

    .weather {
      // flex: 2;
      transition: all .5s linear;
      margin-left: 8px;
    }

    .weather:hover {
      cursor: pointer;
      color: #3481ff;
    }

    .icon {
      img {
        margin-left: 10px;
      }

      img:hover {
        cursor: pointer;
      }

      .weixin1:hover+img,
      .computer1:hover+img {
        display: block;
      }

      .weixin2,
      .computer2 {
        position: absolute;
        width: 120px;
        height: 120px;
        z-index: 999;
        display: none;
      }
    }
  }
}

.active span {
  background-color: rgba(54, 137, 255, 1);
}

/*nav*/
/*2020.6.2修改start*/
.nav {
  background: rgb(28, 116, 205);
  height: 66px;
  position: relative;
  margin-top: -6px;
}

.nav ul.navtitle {
  position: relative;
  display: flex;
}

.nav ul.navtitle>li {
  width: 171.42px;
  background: rgb(28, 116, 205);
}

.nav ul.navtitle>li:hover {
  transition: all 0.6s ease;
}

.nav ul.navtitle>li>a {
  color: #fff;
  line-height: 66px;
  display: block;
  text-align: center;
  transition: 0.4s;
  position: relative;
  font-size: 20px;
  font-weight: lighter;
}

.nav ul.navtitle li i {
  content: "";
  width: 0;
  height: 2px;
  /* background: #ab2e33; */
  background: rgb(28, 116, 205);
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.6s ease;
}

.nav .navtitle>li:hover {
  background: #fff;

  >a {
    color: #3481ff !important;
  }
}

.nav .navtitle>.isSelect {
  background-color: #fff;

  >a {
    color: #3481ff !important;
  }
}

.nav .navtitle>li.dd>a,
.nav .navtitle>li:hover>a {
  /* color: #ac2e33; */
  color: rgb(28, 116, 205);
  transition: all 0.6s ease;
}

.nav .navtitle>li.dd i,
.nav .navtitle>li:hover i {
  width: 37px;
  transition: all 0.6s ease;
}

.newsTitle {
  width: 100%;
  height: 100px;
  position: absolute;
  top: 66px;
  left: 0px;
  background: linear-gradient(92deg, #fff, 50%, rgba(255, 255, 255, 1));
  z-index: 6;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  /* 定义过渡效果 */
}

.show {
  opacity: 1;
  /* 改变透明度以显示 */
  display: block;
  /* 显示 div */
}

.newsTitle ul li:hover {
  transition: all 0.6s ease;
}

.secondMenu a {
  font-size: 20px;
  // font-size: 20px;
  // line-height: 100px;
  // padding-left: 20px;
}

.secondMenu a:hover {
  color: #1c74cd;
}

.wrap {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.newsTitle {
  height: 0;
  transition: 0.4s;
  opacity: 0;
  overflow: hidden;

  ul {
    height: 100%;
  }

  ul li {
    display: flex;
    height: 100%;
    gap: 20px;
    padding: 0 20px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      position: relative;
      padding-right: 20px;

      &::after {
        content: "";
        width: 1px;
        height: 1em;
        background: #dedede;
        position: absolute;
        right: 0;
        top: 40px;
      }

      &:last-child {
        padding-right: 0;

        &::after {
          display: none;
        }
      }
    }
  }
}

.newsTitle.active {
  opacity: 1;
  height: 100px;
}

.breadcrumb_back:hover {
  color: rgb(28, 116, 205) !important;
}

.fixed_box {
  position: fixed;
  right: 0;
  width: 360px;
  z-index: 1000;
  top: 0px;
  background: linear-gradient(#A3D7FF, #D0EDFF);
  padding: 15px;
  box-sizing: border-box;
  line-height: 25px;
  text-indent: 1em;
  font-size: 14px;
  color: #333333;
  padding-top: 20px;
}

.el-icon-close:hover {
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .mobile {
    display: block;
  }

  .navtitle .show {
    opacity: 0;
    /* 改变透明度以不显示 */
    display: none;
  }

  .fixed_box {
    display: none;
  }

  .breadcrumb {
    display: none;
  }

  i.active {
    width: 37px !important;
  }

  .nav .navtitle>li.dd i {
    width: 0;
  }

  .nav {
    height: auto;
    background: #fff;
  }

  .wrap {
    flex-wrap: wrap;
  }

  .nav ul.navtitle>li {
    width: 25%;
  }

  .nav ul.navtitle li i {
    top: 90%;
  }

  .nav ul.navtitle>li>a {
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
  }

  .newsTitle {
    display: none;
  }

  .head {
    display: none;
  }

  .wzayd {
    display: none !important;
  }

  .head {
    // text-align: left !important;
    display: none !important;
    // width: 100% !important;
  }

  // .nav {
  //   width: 100% !important;
  //   height: 55px !important;
  //   overflow: hidden;
  // }

  .dd a i {
    // display: none !important;
  }

  .navtitle {

    // width: 100% !important;
    li {
      background: #fff !important;
      // width: 50px !important;

      a {
        color: #000 !important;
        // line-height: 55px !important;
      }

      a:hover {
        color: #000 !important;
        font-weight: 900;
      }
    }
  }
}
</style>
